<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class=" font-weight-semibold" style="color:#2F2F2F; font-size: 16px;">QR mendatang dari QTRUST</h3>
            <div class="d-flex flex-row align-items-center">
                <div class="d-flex flex-row align-items-center">
                    <div style="background-color: white; border-radius: 4px; position: relative; border: 0">
                        <span style="pointer-events: none; position: absolute; top: 0; bottom: 0; inset-inline-start: 0px; width: 40px; place-content: center; color: rgb(107 114 128); display: grid;">
                            <img src="/icon/iconly-calendar.svg" alt="calendar" style="width: 16px; height: 16px; object-fit: contain;" />
                        </span>
                        <flat-pickr ref="datepicker" v-model="selected.date" :config="dateRangeConfig"></flat-pickr>
                    </div>
                    <div style="width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.status"
                            :options="['INTRANSIT' , 'RECEIVED']"
                            class="qtrust-select"
                            placeholder="Semua Status"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th>No PO</th>
                        <th>Tanggal Pengiriman</th>
                        <th>Jumlah QR</th>
                        <th>Status</th>
                        <th>Tanggal Receipt </th>
                    </tr>
                </thead>
                <tbody v-if="data">
                    <tr v-for="(dat, index) in data" :key="index">
                        <td>{{ dat.po_no ? dat.po_no : '-' }}</td>
                        <td>{{ dat.delivery_at ? moment(dat.delivery_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                        <td>{{ dat.qty ? numberWithCommas(dat.qty) : '-' }}</td>

                        <!-- Status Start -->
                            <td v-if="dat.status.toUpperCase() == 'RECEIVED'">Received</td>
                            <td v-else-if="isUserSE">In-Transit</td>
                            <td v-else>
                                <div class="qtrust-custom-select">
                                    <select
                                        v-model="dat.status"
                                        @change="confirmUpdate(dat, index)"
                                    >
                                        <option
                                            v-for="(status, sIdx) in options.status"
                                            :key="sIdx"
                                            :value="status.value"
                                            :disabled="status.isDisabled"
                                        >{{ status.label }}</option>
                                    </select>
                                    <i class="fas fa-caret-down" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: black;"></i>
                                </div>
                            </td>
                            <!-- Status End -->

                        <td>
                            {{ dat.received_at ? moment(dat.received_at).format('DD MMM YYYY | HH:mm') : '-' }}
                            <i v-if="dat.received_at" class="fa fa-file-download ml-2 clickAble" title="Download BAST" @click="printReceiptMethod(dat)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>

        <!-- Modal Start -->
        <!-- Confirmation Modal Start -->
        <transition name="modal">
            <div v-if="modal.confirmation" class="confirm-modal-mask">
                <div class="confirm-modal-wrapper" @click="modal.confirmation = false">
                    <div class="confirm-modal-container" @click.stop>
                        <!-- Header -->
                        <div class="confirm-header d-flex justify-content-between align-items-center">
                            <h6 class="confirm-title mb-0">Konfirmasi Penerimaan QR</h6>
                            <button type="button" class="btn btn-close-confirm" @click="modal.confirmation = false">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <!-- Body Content -->
                        <div class="confirm-body text-center">
                            <div class="confirm-icon-wrapper">
                                <svg width="108" height="98" viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M53.493 2.18918C61.9236 -2.48607 72.6478 0.58571 77.359 8.94096L122.425 87.1547C123.417 89.4893 123.851 91.3877 123.975 93.3597C124.223 97.9674 122.611 102.446 119.45 105.893C116.288 109.327 112.011 111.354 107.362 111.6H16.6092C14.6875 111.483 12.7659 111.047 10.9682 110.371C1.97967 106.747 -2.3596 96.5482 1.29778 87.7077L46.6741 8.88567C48.2239 6.11492 50.5795 3.72507 53.493 2.18918ZM61.9856 76.0902C59.0101 76.0902 56.5305 78.5476 56.5305 81.5027C56.5305 84.4454 59.0101 86.909 61.9856 86.909C64.9611 86.909 67.3786 84.4454 67.3786 81.4351C67.3786 78.4923 64.9611 76.0902 61.9856 76.0902ZM61.9856 37.7604C59.0101 37.7604 56.5305 40.1503 56.5305 43.1054V60.4855C56.5305 63.4344 59.0101 65.898 61.9856 65.898C64.9611 65.898 67.3786 63.4344 67.3786 60.4855V43.1054C67.3786 40.1503 64.9611 37.7604 61.9856 37.7604Z" fill="#F36F21"/>
                                </svg>
                            </div>

                            <div class="confirm-text">
                                <p class="mb-1">Anda akan menerima <strong>{{ modal.confirmationData ? numberWithCommas(modal.confirmationData.qty) : 0 }}</strong> QR</p>
                                <p class="mb-0 text-muted-sub">Apa anda yakin jumlahnya sudah benar?</p>
                            </div>
                        </div>

                        <!-- Actions -->
                        <div class="confirm-actions d-flex justify-content-center align-items-center">
                            <button 
                                type="button" 
                                class="btn btn-confirm-batal" 
                                @click="modal.confirmation = false"
                            >
                                Batal
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-confirm-submit" 
                                @click="modal.bastConfirmation = true; modal.confirmation = false;"
                            >
                                Ya, Proses
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <!-- Confirmation Modal End -->

        <!-- BAST Confirmation Modal Start -->
        <bast-confirmation
            v-if="modal.bastConfirmation"
            :data="modal.confirmationData"
            @closeModal="modal.bastConfirmation = false"
            @goBack="modal.bastConfirmation = false; modal.confirmation = true;"
            @refreshData="config.page = 1; fetchPaginated()"
        ></bast-confirmation>
        <!-- BAST Confirmation Modal End -->

        <print-receipt ref="printReceipt" :data="receiptData"/>
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    import bastConfirmation from './bastConfirmation.vue';
    import PrintReceipt from './printReceipt.vue';

    export default {
        data () {
            let start = moment().subtract(14, 'days').format("YYYY-MM-DD");
            let end = moment().format("YYYY-MM-DD");
            return {
                moment: moment,
                modal: {
                    confirmation: false,
                    confirmationData: null,
                    bastConfirmation: false,
                },
                receiptData : null,
                dateRangeConfig: {
                    mode: "range",
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altInputClass: "flatpickr-alt",
                    onOpen: this.onFlatpickrOpen,
                    onClose: this.onCloseFlatpickr
                },
                data : null,

                options : {
                    status: [
                        {label: 'In-Transit', value: 'INTRANSIT'},
                        {label: 'Received', value: 'RECEIVED'},
                    ]
                },
                selected: {
                    date: `${start} to ${end}`,
                },
                filter : {
                    start_date: start,
                    end_date: end,
                    status: null,
                },
                config : {
                    page: 1,
                    limit: 15,
                    lastPage: 0,
                    total: 0,
                },
            }
        },
        components : {
            bastConfirmation,
            PrintReceipt
        },
        computed: {
            isUserSE() {
                return this.$store.state.userData.userData.role === 'USER SE';
            }
        },
        mounted () {
            this.fetchPaginated();
        },
        watch : {
            'selected.date'() {
                // this.setDateFilter(dates, this);
            },
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchPaginated();
                },
            },
            'config.page' : {
                deep: true,
                handler: 'fetchPaginated'
            }
        },
        methods : {
            async printReceiptMethod(data) {
                // console.log(this.$refs.printReceipt)
                try {

                    let id = data.id
                    let response = await this.$http.get('/api/qrs/receipt/' + id)

                    this.receiptData = response.data.data
                    console.log(this.receiptData)

                    this.$refs.printReceipt.generateReport()
                }
                catch(err) {
                    console.log(err)
                }
                
            },
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            setDateFilter: debounce((dates, vm) => {
                vm.filter.start_date = dates[0];
                vm.filter.end_date = dates[1] ? dates[1] : dates[0];
            }, 2000),
            confirmUpdate(data, index) {
                if (this.isUserSE) return;
                this.data[index].status = 'INTRANSIT';
                this.modal.confirmationData = data;
                this.modal.confirmation = true;
            },
            fetchPaginated () {
                this.$http.get(`/api/qrs/receipt`, {params: {...this.filter, ...{page: this.config.page, limit: this.config.limit}}})
                .then(async res => {
                    let data = res.data.data;
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch((err)=>console.log(err));
            },
            onCloseFlatpickr(selectedDates) {
                if (selectedDates.length === 2) {
                    const formatDate = (date) => {
                        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                    };
                    const date1 = formatDate(selectedDates[0]);
                    const date2 = formatDate(selectedDates[1]);
                    this.setDateFilter([date1, date2], this);
                    this.afterSelectedFilter = true;
                }   
            },
            onFlatpickrOpen() {
                if (this.afterSelectedFilter) {
                    this.$refs.datepicker.fp.close();
                    this.afterSelectedFilter = false;
                }
            },
        }
    }
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
    }

    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 14px;
        color: black;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 14px;
    }
</style>

<style scoped>
    .clickAble:hover {
        cursor: pointer;
        opacity: 70%;
    }

    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-custom-select {
        border:1px solid #E8E8E8;
        min-width: 100px;
        /* width: 100px; */
        display: inline-block;
        border-radius: 4px;
        position: relative;
    }
    .qtrust-custom-select select {
        width: 100%;
        height: 100%;
        padding: 2px 5px;
    }

    /* Confirmation Modal Specific Styles */
    .confirm-modal-mask {
        position: fixed;
        z-index: 1060;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.45);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.3s ease;
        padding: 20px;
    }

    .confirm-modal-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .confirm-modal-container {
        width: 401px;
        max-width: 401px;
        height: 330px;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
        padding: 16px 20px 20px 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        transform: rotate(0deg);
        opacity: 1;
    }

    .confirm-header {
        width: 100%;
    }

    .confirm-title {
        font-size: 14px;
        font-weight: 600;
        color: #111827;
    }

    .btn-close-confirm {
        padding: 0;
        border: none;
        background: transparent;
        color: #111827;
        font-size: 16px;
        cursor: pointer;
        line-height: 1;
    }

    .btn-close-confirm:hover {
        color: #6B7280;
    }

    .confirm-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto 0;
    }

    .confirm-icon-wrapper {
        margin-bottom: 14px;
    }

    .confirm-icon-wrapper svg {
        display: block;
    }

    .confirm-text {
        font-size: 13px;
        color: #1F2937;
        line-height: 1.4;
    }

    .confirm-text p {
        font-size: 13px;
        color: #1F2937;
    }

    .confirm-text strong {
        font-weight: 700;
        color: #111827;
    }

    .text-muted-sub {
        font-size: 13px;
        color: #374151;
        margin-top: 4px;
    }

    .confirm-actions {
        margin-top: 8px;
    }

    .btn-confirm-batal {
        background: transparent;
        border: none;
        color: #F36F21;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 24px;
        margin-right: 16px;
        cursor: pointer;
        box-shadow: none;
    }

    .btn-confirm-batal:hover {
        color: #D95D16;
        background: transparent;
    }

    .btn-confirm-submit {
        background-color: #F36F21;
        border: 1px solid #F36F21;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        padding: 9px 36px;
        min-width: 140px;
        box-shadow: none;
        cursor: pointer;
        transition: background-color 0.2s;
    }

    .btn-confirm-submit:hover {
        background-color: #D95D16;
        border-color: #D95D16;
        color: #FFFFFF;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .confirm-modal-container,
    .modal-leave-active .confirm-modal-container {
        -webkit-transform: scale(1.05);
        transform: scale(1.05);
    }

    .qtrust-custom-select.is-disabled {
    background-color: #F3F4F6;
    cursor: not-allowed;
    }

    .qtrust-custom-select.is-disabled select {
        cursor: not-allowed;
        color: #6B7280;
        background-color: transparent;
    }

    .qtrust-custom-select.is-disabled i {
        color: #9CA3AF !important; /* override inline style caret */
    }
</style>